import Observable from './observable';
function noop() { }
export default function catchError(callback, stream) {
    const subscriber = typeof callback === 'function' ? { next: noop, complete: noop, error: callback } : callback;
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return new Observable(function factory(observer) {
        const subscription = stream.subscribe({
            next(value) {
                subscriber.next(value);
                observer.next(value);
            },
            error(value) {
                subscriber.error(value);
                observer.error(value);
            },
            complete() {
                subscriber.complete();
                observer.complete();
            },
        });
        return function unsubscribe() {
            subscription.unsubscribe();
        };
    });
}
//# sourceMappingURL=catch-error.js.map